import React from "react";
import StorySection from "./StorySection";

const RedSection = () => {
  return (
    <div className="bg-white w-full flex justify-center items-center">
      <div className="w-full max-w-[1600px]">
        <StorySection />
      </div>
    </div>
  );
};

export default RedSection; 